function Unauthorized(message) {
  this.name = "Unauthorized";
  this.message = message || "";
  this.stack = new Error().stack;
}
Unauthorized.prototype = Object.create(Error.prototype);
Unauthorized.prototype.constructor = Unauthorized;

export default Unauthorized;
